import { wrapClientApiCall } from '../../../utils'

export const fetchUserInfo = token =>
    wrapClientApiCall({
        actionRoot: 'FETCH_USER_INFO',
        url: `api/consumer`,
        token, // handle the case of fetching user data just after sign-up
        successPayload: ({ consumer }) => consumer,
    })
